import { addCallback, removeCallback } from '../lib/teact/teactn';
import { getActions, getGlobal } from '../global';

import type { GlobalState } from '../global/types';
import type { ShellOpenChatRequest } from './browser/shellContainer';

import { selectChat } from '../global/selectors';
import { setShellOpenChatHandler } from './browser/shellContainer';
import { callEventWebReadyNative } from './nativeBridge';

const OPEN_CHAT_WAIT_MS = 20000;

let pending: ShellOpenChatRequest | undefined;
let deadlineTimeout: number | undefined;

function openRequest(request: ShellOpenChatRequest) {
  const actions = getActions();
  if (request.messageId) {
    actions.focusMessage({
      chatId: request.chatId,
      messageId: request.messageId,
      shouldReplaceHistory: true,
    });
  } else {
    actions.openChat({ id: request.chatId, shouldReplaceHistory: true });
  }
}

function clearPending() {
  pending = undefined;
  removeCallback(onGlobalChange);
  if (deadlineTimeout) {
    window.clearTimeout(deadlineTimeout);
    deadlineTimeout = undefined;
  }
}

function areActionsReady() {
  const actions = getActions();
  return typeof actions.openChat === 'function' && typeof actions.focusMessage === 'function';
}

function tryOpen(global: GlobalState) {
  if (!pending) return;
  if (global.authState !== 'authorizationStateReady') return;
  if (!areActionsReady()) return;
  if (!selectChat(global, pending.chatId)) return;

  const request = pending;
  clearPending();
  openRequest(request);
}

function onGlobalChange(global: GlobalState) {
  tryOpen(global);
}

function onDeadline() {
  const request = pending;
  clearPending();
  if (!request) return;
  if (getGlobal().authState !== 'authorizationStateReady') return;
  if (!areActionsReady()) return;

  getActions().openChat({ id: request.chatId, shouldReplaceHistory: true });
}

function handleOpenChat(request: ShellOpenChatRequest) {
  clearPending();
  pending = request;
  addCallback(onGlobalChange);
  deadlineTimeout = window.setTimeout(onDeadline, OPEN_CHAT_WAIT_MS);
  tryOpen(getGlobal());
}

export function initShellOpenChat() {
  setShellOpenChatHandler(handleOpenChat);
  callEventWebReadyNative();
}
